export enum MessageType {
  INFO = 'INFO',
  ERROR = 'ERROR',
}
